import React, { useRef, useState } from 'react';
import styled from 'styled-components';
import emailjs from 'emailjs-com';

const ContactWrapper = styled.section`
  min-height: 60vh;
  padding: 2rem;
  background-color: #2e3244;
  color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const FormContainer = styled.form`
  max-width: 500px;
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const FormField = styled.input`
  padding: 0.75rem;
  margin-bottom: 1rem;
  border-radius: 5px;
  border: none;
`;

const TextArea = styled.textarea`
  padding: 0.75rem;
  margin-bottom: 1rem;
  border-radius: 5px;
  border: none;
  height: 150px;
`;

const SubmitButton = styled.button`
  padding: 0.75rem;
  background-color: #3498db;
  border: none;
  border-radius: 5px;
  color: #fff;
  cursor: pointer;
  &:hover {
    background-color: #1d73c8;
  }
`;

function ContactPage() {
  const formRef = useRef();
  const [feedback, setFeedback] = useState('');

  const sendEmail = (e) => {
    e.preventDefault();
    // Replace your_service_id, your_template_id, and your_user_id with actual EmailJS params
    emailjs.sendForm('your_service_id', 'your_template_id', formRef.current, 'your_user_id')
      .then((result) => {
        console.log(result.text);
        setFeedback('Message sent! We will get back to you soon.');
        formRef.current.reset();
      }, (error) => {
        console.log(error.text);
        setFeedback('An error occurred. Please try again later.');
      });
  };

  return (
    <ContactWrapper>
      <h2>Contact Us</h2>
      <p>Have questions or need support? Send us a message!</p>
      <FormContainer ref={formRef} onSubmit={sendEmail}>
        <FormField type="text" name="name" placeholder="Your Name" required />
        <FormField type="email" name="email" placeholder="Your Email" required />
        <TextArea name="message" placeholder="Your Message" required />
        <SubmitButton type="submit">Send</SubmitButton>
      </FormContainer>
      {feedback && <p style={{ marginTop: '1rem' }}>{feedback}</p>}
    </ContactWrapper>
  );
}

export default ContactPage;
